export default "__VITE_PUBLIC_ASSET__cd36d044__"